import { accountRoles } from './account';

export const subscriptionFees = {
    [accountRoles.Essential]: 0,
    [accountRoles.Premium]: 497,
    [accountRoles.PremiumPlus]: 997,
};
